import { FONT } from "@/styles/common";
import { Center, Divider, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)`
    flex-shrink: 0;
    color: ${({ theme }) => theme.COLOR.text[300]};
    ${FONT("notoSerif", 40, 500)};

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("notoSerif", 24, 500)}
    }
`;

export const CustomDivider = styled(Divider)`
    border: 1px solid ${({ theme }) => theme.COLOR.text[300]};
`;

export const CustomCenter = styled(Center)`
    background: ${({ theme }) => theme.COLOR.pagination[100]};
`;

export const CustomBox = styled(Flex)`
    & > div > div:first-of-type p:first-of-type {
        ${FONT("notoSerif", 14, 700)}
    }
`;

export const CustomText = styled(Text)`
    color: ${({ theme }) => theme.COLOR.text[300]};
`;
